import { isAuthenticated } from './auth';

export default {
    namespaced: true,
    state: {
        title: 'NowYu.ME',
        sidebar: true,
        currentColor: 'deep-purple',
        breadcrumbItems: [],
        route: undefined,
    },
    getters: {
        showToolbar: state => (state.route ? state.route.showToolbar || false : false),
        showFooter: state => (state.route && (state.route.showFooter !== undefined)
                                ? state.route.showFooter
                                : true
                            )
                            && isAuthenticated(),
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        TITLE(state, data) {
            state.title = data;
        },
        SIDEBAR(state, data) {
            state.sidebar = data;
        },
        BREADCRUMBS(state, data) {
            state.breadcrumbItems = data;
        },
        ROUTE(state, data) {
            state.route = data;
            state.title = data.title;
        },
    },
    actions: {
    },
};



// WEBPACK FOOTER //
// ./src/store/nav.js